import { call, put, select } from "redux-saga/effects";
import { getEmployeesProductsInfo } from "@bitComponents/adabyronLayer/employees";
import { WEB_SERVICES } from "./webServices";

const contextStore = (state) => state.context.data;

export function* getEmployeesProducts(params) {
  const { normalizeHttpErrors, showError } =
    params;
  try {
    const context = yield select(contextStore);
    const { response } = yield call(getEmployeesProductsInfo, {context});
    return response;
  } catch (error) {
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_EMPLOYEES_PRODUCTS, error);

    if (showError) {
      yield put(showError(errorNormalized));
    }
    throw error;
  }
}